import { App, URLOpenListenerEvent } from '@capacitor/app';

export const useDeepLinking = router => {
  App.addListener('appUrlOpen', function (event: URLOpenListenerEvent) {
    // Example url: https://beerswift.app/tabs/tabs2
    // slug = /tabs/tabs2
    const slug = event.url.split('.app').pop();

    // We only push to the route if there is a slug present
    if (slug) {
      router.push({
        path: slug
      });
    }
  });
};
